import React, { useEffect } from "react";

function VideosPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Videos Section */}
      <section className="bg-gradient-to-br from-sky-100 to-sky-200 pt-10 pb-[50px]">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl md:text-6xl font-black text-center mb-6 text-sky-600" style={{ fontFamily: "'Chalkboard SE', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
            Jump Into the Sandbox! 🎬
          </h2>
          <p className="text-xl md:text-2xl text-center text-gray-700 mb-5 font-semibold">
            Watch our latest adventures and learn something new!
          </p>

          <div className="flex justify-center mb-12">
            <a
              href="https://www.youtube.com/@tinytotssandbox"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#FF0000] hover:bg-red-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transform transition-all duration-300 hover:scale-105">

              View All Videos on YouTube
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Video Card 1 - Positive Vibes & Affirmations */}
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl border-4 border-pink-300">
              <div className="relative">
                <img
                  src="https://static.lumi.new/material/6e/6ec36cecc9dc3a93656b393daa10480f.jpg"
                  alt="Positive Vibes & Affirmations"
                  className="w-full h-48 object-cover" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute bottom-4 left-4 text-white font-bold text-xl">

                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-black text-pink-600 mb-2 text-center">Positive Vibes</h3>
                <p className="text-gray-600 mb-4 text-center">Build confidence with uplifting messages and positive thoughts!</p>
                <a
                  href="https://www.youtube.com/watch?v=6sQpIqeK-r4"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-pink-500 hover:bg-pink-600 text-white font-bold py-3 px-6 rounded-full shadow-lg transform transition-all duration-300 hover:scale-105 text-center">
                  Watch Now ▶️
                </a>
              </div>
            </div>

            {/* Video Card 2 - STEAM Team */}
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl border-4 border-sky-300">
              <div className="relative">
                <img
                  src="https://static.lumi.new/material/41/41ac3eb0cd4bf93bfd70c50075dd9bb9.jpg"
                  alt="STEAM Team"
                  className="w-full h-48 object-cover" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute bottom-4 left-4 text-white font-bold text-xl">

                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-black text-sky-600 mb-2 text-center">STEAM Team</h3>
                <p className="text-gray-600 mb-4 text-center">Explore the wonders of science, tech, engineering, art, and math!</p>
                <a
                  href="https://www.youtube.com/watch?v=tqDrPB9-8lc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-sky-500 hover:bg-sky-600 text-white font-bold py-3 px-6 rounded-full shadow-lg transform transition-all duration-300 hover:scale-105 text-center">
                  Watch Now ▶️
                </a>
              </div>
            </div>

            {/* Video Card 3 - Healthy Heroes */}
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl border-4 border-lime-300">
              <div className="relative">
                <img
                  src="https://static.lumi.new/material/84/84acacda25cfddaca26e3d07abc27eed.jpg"
                  alt="Healthy Heroes"
                  className="w-full h-48 object-cover" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute bottom-4 left-4 text-white font-bold text-xl">

                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-black text-lime-600 mb-2 text-center">Nutrition Fun</h3>
                <p className="text-gray-600 mb-4 text-center">Learn about healthy eating and making smart food choices!</p>
                <a
                  href="https://www.youtube.com/watch?v=wQOz1s0V_Vo"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-lime-500 hover:bg-lime-600 text-white font-bold py-3 px-6 rounded-full shadow-lg transform transition-all duration-300 hover:scale-105 text-center">
                  Watch Now ▶️
                </a>
              </div>
            </div>

            {/* Video Card 4 - ABC Discovery */}
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl border-4 border-yellow-300">
              <div className="relative">
                <img
                  src="https://static.lumi.new/material/f7/f773d369b73699194647a78bfef81392.jpg"
                  alt="ABC Discovery"
                  className="w-full h-48 object-cover" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute bottom-4 left-4 text-white font-bold text-xl">

                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-black text-yellow-600 mb-2 text-center">Learn Letters</h3>
                <p className="text-gray-600 mb-4 text-center">Join Mr. Fuzz on alphabet adventures and fun learning!</p>
                <a
                  href="https://www.youtube.com/watch?v=M32C2nFAjDY"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-6 rounded-full shadow-lg transform transition-all duration-300 hover:scale-105 text-center">
                  Watch Now ▶️
                </a>
              </div>
            </div>

            {/* Video Card 5 - Wiggle & Jump */}
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl border-4 border-orange-300">
              <div className="relative">
                <img
                  src="https://static.lumi.new/material/e8/e85aeeb5fad7c24595d7e92a4b7c315b.jpg"
                  alt="Wiggle & Jump"
                  className="w-full h-48 object-cover" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute bottom-4 left-4 text-white font-bold text-xl">

                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-black text-orange-600 mb-2 text-center">Movement Time</h3>
                <p className="text-gray-600 mb-4 text-center">Get up and move with fun exercises and active play!</p>
                <a
                  href="https://www.youtube.com/watch?v=21nyCZGweRM"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-6 rounded-full shadow-lg transform transition-all duration-300 hover:scale-105 text-center">
                  Watch Now ▶️
                </a>
              </div>
            </div>

            {/* Video Card 6 - Read & Imagine */}
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl border-4 border-purple-300">
              <div className="relative">
                <img
                  src="https://static.lumi.new/material/b0/b01a3cdb3af5ce9f75c6e152295afe7f.jpg"
                  alt="Read & Imagine"
                  className="w-full h-48 object-cover" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute bottom-4 left-4 text-white font-bold text-xl">

                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-black text-purple-600 mb-2 text-center">Sandbox Adventure</h3>
                <p className="text-gray-600 mb-4 text-center">Dive into magical stories and spark your imagination!</p>
                <a
                  href="https://www.youtube.com/watch?v=KSQNglgYGGQ"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-purple-500 hover:bg-purple-600 text-white font-bold py-3 px-6 rounded-full shadow-lg transform transition-all duration-300 hover:scale-105 text-center">
                  Watch Now ▶️
                </a>
              </div>
            </div>

            {/* Video Card 7 - Mindful Moments */}
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl border-4 border-teal-300">
              <div className="relative">
                <img
                  src="https://static.lumi.new/material/0b/0b0434516624ba43d176356e16bd8584.jpg"
                  alt="Dream Big & Tall"
                  className="w-full h-48 object-cover" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute bottom-4 left-4 text-white font-bold text-xl">

                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-black text-teal-600 mb-2 text-center">Dream Big</h3>
                <p className="text-gray-600 mb-4 text-center">Learn how being brave and standing tall can change the world from the heart.</p>
                <a
                  href="https://www.youtube.com/watch?v=TLKhlYfsGxA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-teal-500 hover:bg-teal-600 text-white font-bold py-3 px-6 rounded-full shadow-lg transform transition-all duration-300 hover:scale-105 text-center">
                  Watch Now ▶️
                </a>
              </div>
            </div>

            {/* Video Card 8 - Clean-Up Dance! */}
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl border-4 border-blue-300">
              <div className="relative">
                <img
                  src="https://static.lumi.new/material/f1/f192dc764a68efd634673a20020212ac.jpg"
                  alt="Clean-Up Dance!"
                  className="w-full h-48 object-cover" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute bottom-4 left-4 text-white font-bold text-xl">

                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-black text-blue-600 mb-2 text-center">Clean-Up Dance!</h3>
                <p className="text-gray-600 mb-4 text-center">Turn tidy time into a party while counting toys and dancing along!</p>
                <a
                  href="https://www.youtube.com/watch?v=9HhACexkOqg"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-6 rounded-full shadow-lg transform transition-all duration-300 hover:scale-105 text-center">
                  Watch Now ▶️
                </a>
              </div>
            </div>

            {/* Video Card 9 - Never Give Up! */}
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl border-4 border-rose-300">
              <div className="relative">
                <img
                  src="https://static.lumi.new/material/79/79b27852de64d56b7106568a5b297ba3.jpg"
                  alt="Never Give Up!"
                  className="w-full h-48 object-cover" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute bottom-4 left-4 text-white font-bold text-xl">

                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-black text-rose-600 mb-2 text-center">Never Give Up!</h3>
                <p className="text-gray-600 mb-4 text-center">Follow Willow the Fox on a heartwarming journey about courage and trying one more time!</p>
                <a
                  href="https://www.youtube.com/watch?v=bPECSuUsPeo"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-rose-500 hover:bg-rose-600 text-white font-bold py-3 px-6 rounded-full shadow-lg transform transition-all duration-300 hover:scale-105 text-center">
                  Watch Now ▶️
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom CTA Button */}
      <div className="flex justify-center bg-white pt-[48px] pb-[12px]">
        <a
          href="https://www.youtube.com/@tinytotssandbox"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#FF0000] hover:bg-red-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transform transition-all duration-300 hover:scale-105">

          View All Videos on YouTube
        </a>
      </div>
    </div>);

}

export default VideosPage;